// src/ui-runtime/destructive-action-vocabulary.ts
var ANCHORED_DESTRUCTIVE_WORDS = [
  // en
  String.raw`delete|remove|discard|destroy|wipe|erase|purge|truncate|revoke|deactivate|disable|reset|unregister|deregister|uninstall`,
  String.raw`pay|purchase|buy\s?now|place\s?(an?\s+)?order|checkout|unsubscribe|terminate|withdraw|transfer|clear\s?all|cancel\s+(order|subscription|account|plan)`,
  // es
  String.raw`eliminar|borrar|quitar|suprimir|descartar|purgar|revocar|desactivar|restablecer|desinstalar|pagar|comprar|realizar\s?pedido|finalizar\s?compra|dar\s?de\s?baja`,
  // fr — accented AND ASCII spellings, because a PATH routinely drops accents.
  String.raw`supprimer|effacer|retirer|purger|r[ée]voquer|d[ée]sactiver|r[ée]initialiser|d[ée]sinstaller|payer|acheter|passer\s?(la\s?)?commande|r[ée]silier|se\s?d[ée]sabonner`,
  // de — with the oe/ue/ae transliterations a `.de` path uses.
  String.raw`l[öo]schen|loeschen|entfernen|verwerfen|bereinigen|leeren|widerrufen|deaktivieren|deinstallieren|zur[üu]cksetzen|zuruecksetzen|bezahlen|kaufen|bestellen|k[üu]ndigen|kuendigen|abbestellen`,
  // pt — `apagar` and `excluir` are both ordinary spellings of delete.
  // `desinstalar` and `finalizar compra` are spelled identically in Spanish and
  // listed once, in the block above.
  String.raw`excluir|apagar|remover|revogar|desativar|redefinir|cancelar\s+(?:pedido|assinatura|conta|plano)`,
  // it
  String.raw`elimina(re)?|rimuov(i|ere)|cancella(re)?|svuota(re)?|revoca(re)?|disattiva(re)?|reimposta(re)?|disinstalla(re)?|paga(re)?|acquista(re)?|effettua\s?(l.)?ordine`,
  // nl
  String.raw`verwijder(en|d|de)?|wissen|legen|intrekken|deactiveren|opnieuw\s?instellen|de[ïi]nstalleren|betalen|kopen|afrekenen|opzeggen`,
  // sv / da / no — one Scandinavian block; the stems differ by a letter.
  //
  // `töm`/`tøm` ("empty") is spelled WITHOUT the bare `o`, and `köp`/`køb`
  // ("buy") likewise: `t[oø]m` matched the name `Tom` and `k[oö]p` matched Dutch
  // `Kop`, on every English or Dutch page. Neither Scandinavian word is ever
  // written with a plain `o`, so dropping it costs no recall at all.
  String.raw`radera|ta\s?bort|slet(t)?|fjern|t[öø]m|[aå]terkalla|inaktivera|[aå]terst[aä]ll|avinstallera|betala|k[öø]p|k[øo]b|best[aä]ll|s[aä]g\s?upp`,
  // vi — `xóa` and `xoá` are two ordinary spellings of one word.
  String.raw`x[oó]a|xo[aá]|g[oỡ]\s?b[oỏ]|lo[aạ]i\s?b[oỏ]|thu\s?h[oồ]i|v[oô]\s?hi[eệ]u\s?h[oó]a|[dđ][aặ]t\s?l[aạ]i|thanh\s?to[aá]n|mua`,
  // tl
  String.raw`burahin|tanggalin|alisin|bayaran|bilhin`,
  // tr — the ONE language here with enumerated suffixes rather than a stem, and
  // the exception is measured rather than stylistic.
  //
  // `sil` is three characters, so as a left-anchored STEM it fired on the whole
  // English `sil-` family: `Silver`, `Silver plan`, `Silent mode`, `Silence
  // notifications`, `Silicon`, `Silk`, `Silhouette`, `Silo`. That is the trade
  // `destructive-action-words.ts` explicitly forbids — "a bare `order` is not
  // listed, because 'Order history' is a read and flagging it would train
  // operators to click through confirmations" — and `Silver` is a more common
  // SaaS tier label than `order` is a verb. It also reaches the TOUR, which
  // declines to press a destructively-named control, so an English site's
  // `Silence notifications` became unopenable.
  //
  // The suffixes cover the forms a UI actually shows (`Sil`, `Silindi`,
  // `Silinecek`, `Silme`, `Silinsin`). Turkish agglutination is unbounded, so an
  // exotic inflection is a MISS — accepted, because the alternative is firing on
  // every English pricing page. Turkish `silindir` ("cylinder") is refused by
  // the trailing anchor, which is what makes the enumeration safe rather than
  // lucky.
  String.raw`sil(?:i?n(?:di|ir|sin|ecek|mi[sş]|iz|me|e)?|di|er|ecek|iyor|me(?:k|si|di)?|sin)?`,
  String.raw`kald[iı]r(?:[iı]l(?:d[iı]|s[iı]n|acak)?|d[iı]|acak|ma)?`,
  String.raw`temizle(?:n(?:di|sin|ecek)?|di|yin)?|s[iı]f[iı]rla(?:n(?:d[iı]|s[iı]n)?|y[iı]n)?`,
  // Turkish puts the object FIRST, and the stems stop before the consonant that
  // mutates: `abonelik` + accusative is `aboneliği`, so `abonelik` is not a
  // prefix of the form a button actually carries.
  String.raw`(?:abonel|sipari[sş]|hesab|plan)\p{L}*\s+iptal|devre\s?d[iı][sş][iı]`,
  // `[oö]de` as a stem fired on `Odessa` and `Odeon`; the payment forms are few.
  // Bare ASCII `ode` is the English word `Ode`, so only the `ö` form may stand
  // alone; the transliterated spelling a PATH carries (`/odeme`) is admitted
  // with its suffix, which is how it is actually written.
  String.raw`öde(?:me(?:si|ler|yi)?|yin|nir|di)?|odeme(?:si|ler|yi)?|odendi`,
  String.raw`sat[iı]n\s?al(?:[iı]n(?:d[iı])?|ma)?`,
  // fi — `osta` as a stem fired on Polish `Ostatni`; its forms are few too. The
  // rest of Finnish stays a stem in bucket 2.
  String.raw`osta(?:a|isi|kaa|ttu)?`
];
var PREFIX_STEM_DESTRUCTIVE_WORDS = [
  // ru / uk / bg — one Cyrillic block; the stems overlap across the three.
  String.raw`удал|видал|изтри|сотри|стере|очист|отозв|отключ|деактивир|сброс|скинут|оплат|заплат|купи|оформить\s?заказ`,
  // CANCEL is object-qualified here, exactly as it is in the Latin blocks. A
  // bare `отмен` matched `Отмена` — the ordinary dialog Cancel button — so
  // every dialog on every Russian site classified destructive while its English
  // equivalent did not. See the header's "Cancel" note.
  String.raw`отмен\p{L}*\s+(?:заказ|подписк|аккаунт|план|учётн|учетн)`,
  String.raw`скасув\p{L}*\s+(?:замовлення|підписк|обліков|акаунт)`,
  String.raw`отказ\p{L}*\s+(?:поръчк|абонамент|акаунт)`,
  // el — accented AND unaccented, because Greek moves the accent as it
  // inflects: `διαγραφή` is unaccented at the stem and `διαγράψτε` is not, so
  // one stem reaches exactly half the forms. The block already paired
  // `αφαίρεσ`/`αφαιρεσ`; the delete stem was simply never paired.
  String.raw`διαγρα|διαγρά|διάγρα|αφαίρεσ|αφαιρεσ|αφαιρώ|εκκαθάρισ|ανάκλησ|απενεργοποί|επαναφορ|πληρωμ|πληρώ|αγορ`,
  String.raw`ακ[ύυ]ρωσ\p{L}*\s+(?:παραγγελ|συνδρομ|λογαριασμ)`,
  // hi — Devanagari matras are combining marks, so what follows a stem is the
  // next full letter and only the leading anchor works.
  String.raw`हटा|मिटा|निकाल|रद्द|भुगतान|खरीद`,
  // fi — agglutinative: `poista` → `poistaminen` → `poistettu`.
  String.raw`poista|tyhjenn|nollaa|maksa`,
  String.raw`peruut\p{L}*\s+(?:tilaus|tili)`,
  // hu — likewise: `töröl` → `törlés` → `törölve`.
  String.raw`t[oö]rl|t[oö]r[oö]l|elt[aá]vol[ií]t|[uü]r[ií]t|visszavon|deaktiv[aá]l|fizet|megv[aá]s[aá]rl|lemond`,
  // pl — suffix-inflecting, so the imperative-only forms missed the infinitive
  // (`usunąć`) and the past (`Usunięto`). Stems reach all three.
  String.raw`usu[nń]|usuw|skasu|wyczy[sś]|wycofa|dezaktywu|zresetu|odinstalu|zap[lł]a|z[lł][oó][zż]\s?zam[oó]wienie`,
  String.raw`anulu\p{L}*\s+(?:zam[oó]wieni|subskrypcj|kont)`,
  // cs / sk — likewise: `Smažte`, `Odstráňte` are the polite imperatives a
  // button actually carries.
  String.raw`smaz|sma[zž]|odstra[nň]|odstr[aá][nň]|vyma[zž]|vypr[aá]zdn|deaktivova|resetova|odinstalova|zaplat|koupi`,
  String.raw`zru[sš]\p{L}*\s+(?:objedn[aá]vk|p[rř]edplatn|[uú][cč]et)`,
  // ro — `Ștergeți` is the polite imperative; `[sș]terge` could not reach it.
  //
  // Two entries are deliberately NOT the obvious stem. `reset` would be a
  // second, LOOSER copy of the English `reset` in bucket 1 — the same string in
  // two buckets means the looser anchoring silently wins, so `Resettings` would
  // fire. And `pl[aă]t` fires on `Platinum` and `Plate`; the Romanian forms all
  // carry `ă` or a full ending, so naming them costs no recall.
  String.raw`[sș]terg|elimin[aă]|revoc|dezactiv|reseteaz|dezinstal|cump[aă]r`,
  String.raw`anul\p{L}*\s+(?:comanda|abonamentul|contul)`,
  String.raw`pl[ăa]te[sș]t|pl[ăa]ti[tț]|pl[ăa]ti(?:re|m)`,
  // hr / sr (Latin) / sl / bs — `Obrišite` over `Obriši`.
  String.raw`obri[sš]|izbri[sš]|ukloni|isprazn|opozov|deaktivir|resetira|deinstalira`,
  String.raw`otka[zž]\p{L}*\s+(?:narud[zž]b|pretplat|ra[cč]un)`
];
var BARE_DESTRUCTIVE_WORDS = [
  // id / ms — inflects by PREFIX (`hapus` → `menghapus` → `dihapus`), so a
  // leading anchor costs exactly the inflected forms. Bare, like the Semitic
  // block below and for the same reason.
  String.raw`hapus|padam|kosongkan|nonaktifkan|copot\s?pemasangan|batalkan\s+(?:pesanan|langganan|akun)`,
  // ar / fa — one block; Persian shares the script and several stems.
  String.raw`حذف|إزال|ازال|مسح|تعطيل|دفع|شراء|سحب|تحويل|مذ|پاک`,
  String.raw`[إا]لغاء\s*(?:الاشتراك|الطلب|الحساب)`,
  // he
  // The infinitive `להסיר` is `ל` + `הסיר` — with a yod the imperative stem
  // `הסר` does not have, so bare matching does NOT rescue it and both forms are
  // listed. This file's header used `להסיר` as the very example justifying bare
  // matching, and it was the one form bare matching missed.
  String.raw`מחק(?!ר)|מחיק|הסר|הסיר|השבת|שלם|תשלום|קנה|רכיש|משוך|העבר`,
  String.raw`ביטול\s+(?:מנוי|הזמנה|חשבון)|בטל\s+(?:מנוי|הזמנה|חשבון)`,
  // ja
  String.raw`削除|消去|抹消|解約|退会|購入|支払|決済|注文する|無効化`,
  // zh-Hans / zh-Hant
  String.raw`删除|刪除|移除|清空|清除|注销|註銷|停用|重置|购买|購買|支付|付款|结账|結帳|下单|下單|取消订阅|取消訂閱`,
  // ko
  String.raw`삭제|제거|비우기|해지|탈퇴|결제|구매|주문하기|비활성화|초기화`,
  // th
  String.raw`ลบ|ล้าง|ปิดใช้งาน|รีเซ็ต|ชำระเงิน|ซื้อ|สั่งซื้อ`,
  String.raw`ยกเลิก(?:การสมัคร|คำสั่งซื้อ|บัญชี)`
];

// src/ui-runtime/destructive-action-words.ts
function nfkc(entries) {
  return entries.map((entry) => entry.normalize("NFKC")).join("|");
}
var DESTRUCTIVE_ACTION_RE = new RegExp(
  [
    String.raw`(?<!\p{L})(?:${nfkc(ANCHORED_DESTRUCTIVE_WORDS)})(?!\p{L})`,
    String.raw`(?<!\p{L})(?:${nfkc(PREFIX_STEM_DESTRUCTIVE_WORDS)})`,
    String.raw`(?:${nfkc(BARE_DESTRUCTIVE_WORDS)})`
  ].join("|"),
  "iu"
);
var SCRIPT_PRESENTATION_MARKS = (
  // eslint-disable-next-line no-misleading-character-class -- matching LONE combining marks is the intent: this class STRIPS harakat/niqqud, the exact case the rule assumes is accidental
  /[\u0640\u064B-\u065F\u0670\u05B0-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7]/g
);
function foldTextForRiskCheck(text) {
  return text.normalize("NFKC").replace(SCRIPT_PRESENTATION_MARKS, "").replace(TURKISH_DOTTED_I, "i");
}
var TURKISH_DOTTED_I = /\u0130|i\u0307/g;
function namesDestructiveAction(text) {
  return DESTRUCTIVE_ACTION_RE.test(foldTextForRiskCheck(text));
}
function decodePathForRiskCheck(path) {
  let decoded;
  try {
    decoded = decodeURIComponent(path);
  } catch {
    decoded = path;
  }
  return normalizeIdentifierForRiskCheck(decoded);
}
function normalizeIdentifierForRiskCheck(text) {
  return text.replace(/(\p{Ll}|\p{N})(\p{Lu})/gu, "$1 $2").replace(/(\p{Lu}+)(\p{Lu}\p{Ll})/gu, "$1 $2").replace(/[-_]+/g, " ");
}

// src/ui-runtime/word-buckets.ts
var nfkcJoin = (entries) => entries.map((entry) => entry.normalize("NFKC")).join("|");
function compileWordBuckets(buckets) {
  const parts = [];
  if (buckets.anchored.length > 0) {
    parts.push(String.raw`(?<!\p{L})(?:${nfkcJoin(buckets.anchored)})(?!\p{L})`);
  }
  if (buckets.prefixStem.length > 0) {
    parts.push(String.raw`(?<!\p{L})(?:${nfkcJoin(buckets.prefixStem)})`);
  }
  if (buckets.bare.length > 0) {
    parts.push(String.raw`(?:${nfkcJoin(buckets.bare)})`);
  }
  if (parts.length === 0) {
    return /(?!)/u;
  }
  return new RegExp(parts.join("|"), "iu");
}

export { DESTRUCTIVE_ACTION_RE, compileWordBuckets, decodePathForRiskCheck, foldTextForRiskCheck, namesDestructiveAction, normalizeIdentifierForRiskCheck };
//# sourceMappingURL=chunk-DTQUYCTY.js.map
//# sourceMappingURL=chunk-DTQUYCTY.js.map